module.exports = __webpack_public_path__ + "static/media/shopping.a3d81d68.jpg";